import { render, staticRenderFns } from "./ProfileSpeedboatTransactions.vue?vue&type=template&id=47cec918"
import script from "./ProfileSpeedboatTransactions.vue?vue&type=script&lang=js"
export * from "./ProfileSpeedboatTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports